import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import unhandledPromisesAreOk from 'state/middlewares/unhandledPromisesAreOk';
import createSentryMiddleware from 'redux-sentry-middleware';
import * as Sentry from '@sentry/browser';
import ENV from 'config/Environment';

import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import reducers from 'state/reducers';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const history = createBrowserHistory();

// Only exported for tests
export let middleware = [
  unhandledPromisesAreOk,
  thunk,
  promiseMiddleware(),
  routerMiddleware(history)
];

if (process.env.NODE_ENV === 'production') {
  Sentry.init({ dsn: ENV.SENTRY_DSN });
  middleware = [...middleware, createSentryMiddleware(Sentry, {})];
}

export const store = createStore(
  combineReducers({
    ...reducers,
    router: connectRouter(history)
  }),
  composeEnhancers(applyMiddleware(...middleware))
);
